import React from "react";
import { Link } from "react-router-dom";

const AboutContentThree = () => {
  return (
    <div className="how__work">
      {/* <div className="container">
        <div className="row">
          <div className="col-lg-6 col-md-12 col-sm-12 col-12 sm__mt--40 md__mt--40">
            <div className="content">
              <h2>Knowledge Builds Confidence</h2>
              <p>
                From video tutorials to expert-led sessions, The Pips Academy
                helps you master the art of trading at your own pace. At The
                Pips, we make learning to trade simple and practical. Our
                beginner-friendly courses and detailed trading guides walk you
                through every concept, while real-world examples and
                step-by-step tutorials help you apply what you learn. Plus,
                you’ll gain valuable insights and mentorship from experienced
                traders who are here to guide your journey.
              </p>
              <Link
                className="slide__btn dg__btn mt--10"
                to={process.env.PUBLIC_URL + "/company/contact"}
              >
                JOIN WITH US
              </Link>
            </div>
          </div>

          <div className="col-lg-6 col-md-12 col-sm-12 col-12">
            <div className="thumb">
              <img
                src={
                  process.env.PUBLIC_URL + "/images/contents/Illustration_2.jpg"
                }
                alt="computer images"
              />
            </div>
          </div>
        </div>
      </div>
      <br></br> <br></br> */}
      <div className="container">
        <div className="row">
          <div className="col-lg-6 col-md-12 col-sm-12 col-12">
            <div className="thumb-left">
              <img
                src={
                  process.env.PUBLIC_URL +
                  "/images/company/about_us/about_us_3.png"
                }
                alt="computer images"
              />
            </div>
          </div>
          <div className="col-lg-6 col-md-12 col-sm-12 col-12 sm__mt--40 md__mt--40">
            <div className="content-right">
              <h2>Meet Our Team</h2>
              <p>
                Behind The Pips is a team of traders, analysts, and educators
                who share one vision, to make financial growth achievable for
                everyone. With years of market experience and a genuine passion
                for teaching, our experts guide you with insight, mentorship,
                and care, so you can trade confidently and grow steadily. Our
                team works tirelessly to simplify complex market concepts into
                clear, actionable guidance that fits every skill level. We stay
                connected to evolving market trends to ensure you receive
                timely, relevant insights that truly make a difference. Most
                importantly, we’re committed to supporting you not just as a
                trader, but as a learner building long-term financial
                confidence.
              </p>
              <Link
                className="slide__btn dg__btn"
                to={process.env.PUBLIC_URL + "/register"}
              >
                Register now
              </Link>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AboutContentThree;
